import { BrowserRouter } from "react-router-dom";
import { StylesManager } from "survey-core";
import "survey-core/modern.min.css";

import {
  defaultTheme,
  initializeIcons,
  Stack,
  ThemeProvider
} from "@bps/fluent-ui";

import { AnalyticsProvider } from "./analytics/app-insights.provider";
import { SurveyRenderer } from "./components/SurveyRenderer";
import "./fonts.css";

initializeIcons(
  "https://static2.sharepointonline.com/files/fabric/assets/icons/"
);

export const App = () => {
  const defaultThemeColors = StylesManager.ThemeColors["modern"];
  defaultThemeColors["$main-color"] = "var(--primary-color)";
  defaultThemeColors["$main-hover-color"] = "var(--primary-color)";
  defaultThemeColors["$text-color"] = "var(--primary-text-color)";
  defaultThemeColors["$header-color"] = "var(--primary-color)";
  defaultThemeColors["$header-background-color"] = "var(--primary-bg-color)";

  defaultThemeColors["$focus-color"] = "var(--primary-color)";
  defaultThemeColors["$hover-color"] = "var(--primary-color)";

  StylesManager.applyTheme("modern");

  return (
    <BrowserRouter>
      <ThemeProvider theme={defaultTheme}>
        <AnalyticsProvider>
          <Stack styles={{ root: { minHeight: "100svh" } }}>
            <SurveyRenderer />
          </Stack>
        </AnalyticsProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
};
